import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import AdminPage from "@/pages/Admin";
import ReferencesPage from "@/pages/References";
import CustomPageView from "@/pages/CustomPage";
import ScheduleDemo from "@/pages/ScheduleDemo";
import DemoConfirm from "@/pages/DemoConfirm";
import Marketing from "@/pages/Marketing";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import { ImpressumPage, DatenschutzPage, AGBPage } from "@/pages/Legal";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/references" element={<ReferencesPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/schedule-demo" element={<ScheduleDemo />} />
        <Route path="/demo/confirm/:token" element={<DemoConfirm />} />
        <Route path="/marketing" element={<Marketing />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
        <Route path="/agb" element={<AGBPage />} />
        <Route path="/p/:slug" element={<CustomPageView />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
